import { render, staticRenderFns } from "./EmergenciaLocal.vue?vue&type=template&id=6c2bbaa0&scoped=true"
import script from "./EmergenciaLocal.vue?vue&type=script&lang=js"
export * from "./EmergenciaLocal.vue?vue&type=script&lang=js"
import style0 from "./EmergenciaLocal.vue?vue&type=style&index=0&id=6c2bbaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2bbaa0",
  null
  
)

export default component.exports